import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import Header from '../Header/AppHeader';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Alert from 'react-s-alert';
import { ThemeContext } from '../Common/ThemeProvider';
import 'react-s-alert/dist/s-alert-default.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faMobileAlt, faShareAlt, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import axios from 'axios';
import Select from 'react-select';
import TruckMoving from '../../Images/TruckMoving.gif';
import Track from '../../Images/Track.gif';
import Loader from '../Common/Loader';
import whatsapp from '../../Images/whatsapp.png';
import baseURL from '../Common/Config';
import Axiosfetch from '../Common/Axiosfetch';
import FailureAlert from '../Common/Failure';
import TrackRating from '../Tracking/TrackRating';
import Maps from '../Common/Maps';

const auth = {
    username: "AksDtUVhSF",
    password: "3rPfGsBZMi"
};

const TrackingDetails = () => {
    var { trackId } = useParams();
    const { CurrentTheme } = useContext(ThemeContext);
    const [TrackingInfo, setTrackingInfo] = useState([]);
    // eslint-disable-next-line
    const [CustomerID, setCustomerID] = useState([]);
    const [Trips, setTrips] = useState([]);
    const [TrackingMain, setTrackingMain] = useState({});
    const [TripID, setTripID] = useState("");
    const [ShowTrack, setShowTrack] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [displayWhatsappModal, setdisplayWhatsappModal] = useState("none");
    const [displayPartnerContact, setdisplayPartnerContact] = useState("none");
    const [shareNumber, setshareNumber] = useState("");
    const [PartnerContact, setPartnerContact] = useState({});


    useEffect(() => {
        var trip = localStorage.getItem("tripID");

        if (trackId !== undefined) {
            setTripID(trackId);
            OnTrackClick(trackId);
        }
        else if (trip !== null && trip !== undefined) {
            setTripID(trip);
        }

        if (trackId === undefined) {
            FetchTrips();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const TextChange = (e) => {
        setshareNumber(e.target.value);
    }

    const FetchTrips = async () => {
        setLoading(true);
        const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        var isAdmin = (userData && userData.Role !== undefined && userData.Role.length > 0) ? userData.Role[0].Name.toUpperCase() === "ADMIN" : false;

        await axios.get("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test") + "/trips",
            {
                headers: {
                    'Authorization': `Basic ${token}`
                }
            }).then(async function (response) {
                if (response.status === 200) {
                    var data = [];
                    response.data.forEach(trip => {
                        if (isAdmin || (trip.custom_Org !== undefined && trip.custom_Org !== null && trip.custom_Org.toString().indexOf(userData.Organization[0]._id) !== -1)) {
                            data.push({ label: trip.srcname + " - " + trip.destname + " [" + trip.truck_number + "]", value: trip._id })
                        }
                    });

                    data = (data.length > 0) ? data.sort(function (a, b) { return b - a }) : [];
                    setTrips(data);
                    setLoading(false);
                }
            }).catch(function (error) {
                Alert.error("Error loading Tracking Details", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });

                setTripID("");
                setLoading(false);
            });

    };

    const OnTrackClick = async (tripId) => {
        if (tripId !== "") {
            setLoading(true);
            const token = await Buffer.from(`${auth.username}:${auth.password}`, 'utf8').toString('base64');
            await axios.get("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test")
                + "/trips?tripId=" + tripId.trim() + "&addConsents=true",
                {
                    headers: {
                        'Authorization': `Basic ${token}`
                    }
                }).then(async function (response) {
                    if (response.status === 200) {
                        var data = [];
                        console.log(response.data)
                        await setTrackingMain({
                            sourceName: response.data[0].srcname,
                            destName: response.data[0].destname,
                            srcAddress: response.data[0].srcaddress,
                            destAddress: response.data[0].destaddress,
                            startTime: response.data[0].startTime,
                            reached_set_time: response.data[0].reached_set_time,
                            endTime: response.data[0].endTime,
                            invoice: response.data[0].invoice,
                            status: response.data[0].status,
                            tripEndThroughAPI: response.data[0].endThroughAPI,
                            consentStatusDetails: response.data[0].current_db_consent + " (" + response.data[0].consent.result.number + " - " + response.data[0].consent.result.operator + ")",
                            consentStatus: response.data[0].current_db_consent,
                            operator: response.data[0].consent.result.operator,
                            OrgData: response.data[0].custom_Org,
                            TelePhone: response.data[0].tel[0],
                            truck_number: response.data[0].truck_number,
                            totalTravelled: response.data[0].distance_remained !== undefined ? ((response.data[0].distance_travelled + response.data[0].distance_remained) / 1000).toFixed(2) : 0,
                            travelled: (response.data[0].distance_travelled === undefined || response.data[0].distance_travelled === 0) ? 0 : (response.data[0].distance_travelled / 1000).toFixed(2),
                            remaining: (response.data[0].distance_remained === undefined || response.data[0].distance_remained === 0) ? 0 : (response.data[0].distance_remained / 1000).toFixed(2),
                            location: ((response.data[0].ping !== undefined && response.data[0].ping.city !== undefined) ? response.data[0].ping.city : "")
                        });

                        await axios.get("https://sct.intutrack.com/api/" + ((process.env.REACT_APP_TRACK_ISPROD && process.env.REACT_APP_TRACK_ISPROD.toString() === "1") ? "prod" : "test")
                            + "/status?tripId=" + tripId.trim(),
                            {
                                headers: {
                                    'Authorization': `Basic ${token}`
                                }
                            }).then(async function (response) {

                                if (response.data.length > 0) {
                                    for (var i = 0; i < response.data.length; i++) {
                                        await data.push({
                                            time: response.data[i].createdAt,
                                            location: response.data[i].city,
                                            loc: response.data[i].loc
                                        });
                                    }
                                }
                            }).catch(function (error) {
                                Alert.error("Error loading Tracking Details. Check Internet Connection", {
                                    position: 'bottom-right',
                                    effect: 'slide',
                                    html: false
                                });
                                setLoading(false);
                            });

                        data.sort(function (a, b) { return b - a });
                        setTrackingInfo(data);
                        if (response.data[0].custom_Org !== null && response.data[0].custom_Org !== undefined
                            && response.data[0].custom_Org !== "") {
                            GetPartnerDetails(response.data[0].custom_Org);
                        }
                        setLoading(false);
                    }
                }).catch(function (error) {
                    Alert.error("Error loading Tracking Details", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });

                    setLoading(false);
                });
        }
        else {
            Alert.error("Please select valid Trip", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onTripChange = (e) => {
        setTripID(e.target.value);
    };

    const OnTripRemind = () => {
        if (TripID !== "") {
            localStorage.setItem("tripID", TripID.trim());
            Alert.success("Trip Reminder is set to Active", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error("No trip Available.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnTripDropdownChange = (tripdetails) => {
        let Trip = tripdetails ? tripdetails.value : null;
        if (Trip !== null) {
            setTripID(Trip);
        }
    };

    const ShowTracking = () => {
        setShowTrack(!ShowTrack);
    };

    const showWhatsappPopUp = () => {
        setdisplayWhatsappModal("block");
    };

    const hideWhatsappPopUp = () => {
        setdisplayWhatsappModal("none");
        setshareNumber("");
    };

    const GetPartnerDetails = (OrgData) => {
        if (OrgData !== null && OrgData !== undefined) {
            var orgDetails = OrgData.split(';');
            var org = orgDetails.length > 1 ? orgDetails[orgDetails.length - 1] : orgDetails[0];
            Axiosfetch(baseURL + "TrackingPartnerData", "POST", { _id: org }, OrgDetailsSuccess, Failure);
        }
    };

    const hidePartnerContactSection = () => {
        setdisplayPartnerContact("none");
    };

    const showPartnerContactSection = () => {
        setdisplayPartnerContact("block");
    };

    const OrgDetailsSuccess = (data) => {
        if (data.length > 0) {
            setPartnerContact(data[0]);
        }
        else {
            Alert.error("Contact Details unavailable", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            setPartnerContact({});
        }
    };

    const UpdateRating = (SelectedRating) => {
        let tripID = "";
        if (trackId !== undefined) {
            tripID = trackId;
        }
        else {
            tripID = TripID;
        }

        if (tripID !== "") {
            const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

            Axiosfetch(baseURL + "TrackLogRating", "POST", {
                TripId: tripID,
                Rating: SelectedRating,
                RatingBy: userData?._id,
                RatingDate: moment(new Date())
            }, RatingSuccesss, Failure);
        }
        else {
            Alert.error("Please select Trip ID", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const RatingSuccesss = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };


    return (
        <div>
            {trackId === undefined && (<Header></Header>)}
            {trackId !== undefined && PartnerContact && PartnerContact.Name && (<div style={{ color: "#005582", padding: "10px" }} className="align-center">
                <div>
                    <h4>{PartnerContact.Name}</h4>
                </div>
            </div>)}
            <div className={`container-fluid ${(trackId === undefined ? "InvoiceTheme" : "InvoiceTheme-publicurl")} shadow sidemenu-show`}>
                <div className="row">
                    <div className="col-md-1 col-sm-1 align-right trackheader">
                        <img alt="track" src={Track} width="40" height="40"></img>
                    </div>
                    <div className="col-md-6 col-sm-6 align-right trackheader">
                        <div style={{ fontWeight: "500", fontSize: "28px" }}>Tracking Details</div>
                    </div>
                    {trackId === undefined && (<div className="col-md-5 col-sm-5 trackdropdown">
                        <div style={{ width: "80%" }}>
                            <Select styles={{ borderRadius: "20px" }} isClearable={true} isSearchable={true} placeholder="Select Trip"
                                options={Trips}
                                onChange={OnTripDropdownChange}></Select>
                        </div>
                    </div>)}
                </div>
                <div className="row title customerStyle">
                    <div className="col-md-3 col-sm-4" style={{ margin: "auto 0" }}>
                        <div className="trackheader" style={{ fontWeight: "600" }}>Trip ID<span className="mandatoryStar">*</span></div>
                    </div>
                    <div className="col-md-7 col-sm-5">
                        <div style={{ display: "flex" }}>
                            <input disabled style={{ width: "80%", textAlign: "center" }} value={TripID} onChange={onTripChange} className="form-control" type="text"></input>
                            {trackId === undefined && (<span title="Remember this Trip." className={`addressCardStyle ${CurrentTheme}Color`} onClick={OnTripRemind} style={{ fontSize: "25px", paddingLeft: "10px", cursor: "pointer" }}><FontAwesomeIcon icon={faEye} /></span>)}
                            {(trackId === undefined && TrackingMain && TrackingMain.sourceName !== undefined) && (<span className="cursor hover-style" style={{ paddingLeft: "10px", margin: "auto" }} onClick={showWhatsappPopUp}>
                                <img alt="Logo" src={whatsapp} width="25px" height="25px"></img>
                            </span>)}
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-3 align-right trackbtn">
                        <button onClick={() => OnTrackClick(TripID)} className={`btn btn-General ${CurrentTheme}Focus`}>Track Shipment</button>
                    </div>
                </div>
                <div className="row" style={{ margin: "5px" }}>
                    {Loading && (<Loader></Loader>)}
                    {TrackingMain.sourceName !== undefined && (
                        <div className="col-md-12 col-12" style={{ padding: "0", border: "1px solid #ccc", borderRadius: "0 0 6px 6px", marginTop: "10px", marginBottom: "10px" }}>
                            <div style={{ overflow: "auto" }}>
                                <table className="table align-center" style={{ letterSpacing: "0.5px" }}>
                                    <thead>
                                        <tr className={`${CurrentTheme}`} style={{ color: "white" }}>
                                            <th style={{ width: "150px", zIndex: "0" }}>Truck Number</th>
                                            <th style={{ width: "24%", zIndex: "0" }}>Origin</th>
                                            <th style={{ width: "24%", zIndex: "0" }}>Destination</th>
                                            <th style={{ zIndex: "0" }}>Invoice</th>
                                            <th style={{ zIndex: "0" }}>Consent</th>
                                            <th style={{ zIndex: "0" }}>{trackId === undefined ? "Telephone" : "Support"}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{TrackingMain.truck_number}</td>
                                            <td >{TrackingMain.srcAddress}</td>
                                            <td>{TrackingMain.destAddress}</td>
                                            <td>{TrackingMain.invoice}</td>
                                            <td><div><FontAwesomeIcon style={{ color: (TrackingMain.consentStatus === "ALLOWED" ? "green" : (TrackingMain.consentStatus === "PENDING" ? "orange" : "red")) }} icon={TrackingMain.consentStatus === "ALLOWED" ? faThumbsUp : faThumbsDown} />
                                                <span style={{ fontSize: "20px" }}>{` [${TrackingMain.operator}]`}</span>
                                            </div></td>
                                            <td>{trackId === undefined ? TrackingMain.TelePhone :
                                                (<span className="hover-style cursor" style={{ fontSize: "20px" }} onClick={showPartnerContactSection}><FontAwesomeIcon icon={faMobileAlt}></FontAwesomeIcon> </span>)
                                            }</td>
                                        </tr>
                                        <tr>
                                            <td style={{ borderTop: "1px solid #ccc" }} colSpan="4"><span><b>Travelled : {TrackingMain.travelled !== undefined ? TrackingMain.travelled : "0"} KM</b></span></td>
                                            <td style={{ borderTop: "1px solid #ccc" }} colSpan="3"><span><b>Remaining : {(TrackingMain.reached_set_time !== undefined && TrackingMain.reached_set_time !== null &&
                                                TrackingMain.reached_set_time !== "" && moment(TrackingMain.reached_set_time) < moment()) ? "0" : (TrackingMain.remaining !== undefined ? TrackingMain.remaining : "0")} KM</b></span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <div style={{ padding: "10px 30px 20px 30px" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div style={{ width: "40%", paddingBottom: "5px" }}><b>{TrackingMain.sourceName}</b></div>
                                        <div><b>{TrackingMain.destName}</b></div>
                                    </div>
                                    <div style={{ height: "6px", position: "relative", backgroundColor: "#ccc", borderRadius: "10px" }}>
                                        <div className="truck-moving">
                                            <img alt="truck" width="55px" height="55px" src={TruckMoving}></img>
                                        </div>
                                        <div id="currentLoaction" title={TrackingMain.location} style={{
                                            backgroundColor: "green", height: "6px", borderRadius: "10px", width:
                                                ((TrackingMain.reached_set_time !== undefined &&
                                                    TrackingMain.reached_set_time !== null &&
                                                    TrackingMain.reached_set_time !== "" &&
                                                    moment(TrackingMain.reached_set_time) < moment())
                                                    ? 100 : (TrackingMain.totalTravelled !== 0 ? (((TrackingMain.totalTravelled - TrackingMain.remaining) / TrackingMain.totalTravelled) * 100)
                                                        : 0)) + "%"
                                        }}>
                                            {(TrackingMain.reached_set_time !== undefined && TrackingMain.reached_set_time !== null &&
                                                TrackingMain.reached_set_time !== "" && moment(TrackingMain.reached_set_time) < moment()) ? "" : <span style={{ position: "relative", left: "98%", top: "20px", display: "inline-block", width: "250px" }}>{TrackingMain.location}</span>}
                                        </div>
                                        <div className="blink-red" title={TrackingMain.location} style={{
                                            backgroundColor: "#005582", height: "20px", width: "20px", top: "-13px", position: "relative", borderRadius: "10px", left:
                                                ((TrackingMain.reached_set_time !== undefined &&
                                                    TrackingMain.reached_set_time !== null &&
                                                    TrackingMain.reached_set_time !== "" &&
                                                    moment(TrackingMain.reached_set_time) < moment())
                                                    ? 100 : (TrackingMain.totalTravelled !== 0 ? (((TrackingMain.totalTravelled - TrackingMain.remaining) / TrackingMain.totalTravelled) * 100) - 1
                                                        : 0)) + "%"
                                        }}></div>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ textAlign: "center", fontSize: "35px", paddingTop: "10px", fontWeight: "300" }}>
                                        {TrackingMain.tripEndThroughAPI ? "TRIP ENDED By Admin" : ((TrackingMain.reached_set_time !== undefined && TrackingMain.reached_set_time !== null &&
                                            TrackingMain.reached_set_time !== "" && moment(TrackingMain.reached_set_time) < moment()) ? "TRIP COMPLETE" : (TrackingMain.remaining !== undefined ? "IN TRANSIT" : "TRIP COMPLETE"))}
                                    </div>
                                    <div className="cursor onhover" style={{
                                        textAlign: "center", fontWeight: "600",
                                        color: "#005582", fontSize: "17px", paddingTop: "6px", letterSpacing: "1.5px"
                                    }} onClick={ShowTracking}>GET STATUS UPDATES
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    <div className='col-md-12 col-12' style={{ margin: "auto" }}>
                        <TrackRating totalstar={10} showratingValue={true} updaterating={UpdateRating}></TrackRating>
                    </div>
                    <div className="col-md-12 mt-2 mb-4">
                        {TrackingInfo !== null && TrackingInfo.length > 0 && (
                            <div style={{ border: "1px solid #ccc", overflow: "auto" }}>
                                <Maps routes={TrackingInfo}></Maps>
                            </div>)}
                    </div>
                    {ShowTrack && TrackingInfo.length > 0 && (<div className="col-md-12" style={{ paddingTop: "10px" }}>
                        <div className="row" style={{ justifyContent: "space-between", border: "1px solid #ccc", borderRadius: "6px" }}>
                            <div className={`col-md-12 align-center ${CurrentTheme}`} style={{ color: "white", borderRadius: "6px" }}>
                                <h4>Location Tracking</h4>
                            </div>
                            {
                                TrackingInfo.map((data, index) => (
                                    <div key={index} className="col-md-3" style={{ border: "1px solid #ccc", borderRadius: "10px", margin: "10px", padding: "10px" }}>
                                        <div className={`LocationStyle ${CurrentTheme}`}>{index + 1}</div>
                                        <div style={{ textAlign: "center" }}>Location : {data.location}</div>
                                        <div style={{ textAlign: "center" }}>Date : {moment(data.time).local().format("DD/MM/YYYY, hh:mm:ss A")}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>)}
                </div>
                <div id="whatsappModel" className="modal" style={{ display: displayWhatsappModal, paddingTop: "60px" }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Share Tracking</span>
                            <span className="close" onClick={hideWhatsappPopUp}>&times;</span>
                        </div>
                        {TrackingMain && TrackingMain.sourceName && (<div style={{ display: "flex", justifyContent: "center" }}>
                            {/* <img alt="Logo" style={{marginTop:"8px"}} src={whatsapp} width="25px" height="25px"></img> */}
                            <span style={{ fontSize: "20px", padding: "0 10px" }}>+91
                                <input value={shareNumber} placeholder="Whatsapp Number" onChange={TextChange} className="textbox-style" type="text"></input>
                            </span>
                            <a rel="noopener noreferrer" target="_blank" href={`https://wa.me/+91${shareNumber}?text=Tracking : *${TrackingMain.sourceName.toUpperCase()} - ${TrackingMain.destName.toUpperCase()}* , Current Location : *${TrackingMain.location.toUpperCase()}* , Tracking link : http://${window.location.hostname}/TrackingDetails/${(TripID)}`}
                                className="cursor hover-style" style={{ fontSize: "28px" }}>
                                <span title="Whatsapp Share Tracking" style={{ display: (shareNumber !== "" && !isNaN(shareNumber) && shareNumber.length === 10 ? "block" : "none") }}><FontAwesomeIcon icon={faShareAlt}></FontAwesomeIcon></span>
                            </a>
                        </div>)}
                    </div>
                </div>
                <div id="partnerContactModel" className="modal" style={{ display: displayPartnerContact, paddingTop: "60px" }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>Contact Details</span>
                            <span className="close" onClick={hidePartnerContactSection}>&times;</span>
                        </div>
                        {PartnerContact && PartnerContact.Name && (<div style={{ display: "flex", justifyContent: "center" }}>
                            <table className="table table-striped">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "200px" }}><h5>Name</h5></td>
                                        <td><h5>{PartnerContact.Name}</h5></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Contact</h5></td>
                                        <td><h5>
                                            <a style={{ padding: "0 1em", margin: "0 1em" }} className="business-card-support" href={`tel:+91${PartnerContact.Contact}`}>+91 {PartnerContact.Contact}</a>
                                        </h5></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Address</h5></td>
                                        <td><h5>{PartnerContact.AddressLine1 + " " + PartnerContact.AddressLine2 + " , " +
                                            PartnerContact.City + " , " + PartnerContact.State + " , " +
                                            PartnerContact.PostalCode + " , " + PartnerContact.Country}</h5></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Website</h5></td>
                                        <td>
                                            <div style={{ whiteSpace: "normal", fontSize: "20px", cursor: (PartnerContact.Website === "" ? "default" : "pointer"), color: (PartnerContact.Website === "" ? "" : "#005582") }} onClick={() => onWebSiteClick(PartnerContact.Website)}>{PartnerContact.Website}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TrackingDetails;